module.exports = __webpack_public_path__ + "static/img/lbtcg.ec55299.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/lbtcg.jpg
// module id = z5xf
// module chunks = 0